/**
 * Clip utility functions for the Project Editor
 * Shared helpers for duration calculations, etc.
 */

/**
 * Calculate effective duration of a clip considering trim and speed settings
 * @param {Object} clip - The clip object
 * @returns {number} - Effective duration in milliseconds
 */
export const getEffectiveDuration = (clip) => {
  if (!clip) return 0;
  const baseDuration = clip.duration_ms - (clip.trim_start_ms || 0) - (clip.trim_end_ms || 0);
  const speed = clip.settings?.speed ?? 1;
  return baseDuration / speed;
};

/**
 * Get raw clip duration (without speed adjustment) after trimming
 * Used for actual video playback timing since playbackRate handles speed
 * @param {Object} clip - The clip object
 * @returns {number} - Raw duration in milliseconds
 */
export const getRawClipDuration = (clip) => {
  if (!clip) return 5000; // Default 5 seconds
  return clip.duration_ms - (clip.trim_start_ms || 0) - (clip.trim_end_ms || 0);
};

/**
 * Format milliseconds to timecode (MM:SS;FF at 24fps)
 * @param {number} ms - Time in milliseconds
 * @returns {string} - Formatted timecode
 */
export const formatTimecode = (ms) => {
  if (!ms && ms !== 0) return '00:00;00';
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const frames = Math.floor((ms % 1000) / (1000 / 24));
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')};${String(frames).padStart(2, '0')}`;
};
